import * as THREE from "three";
import { createLabel } from "../../../TOOLS/LabelFactory";

export class ChartBar {
    constructor(store, parent, districtid, width, height, plant, year, value, color, city) {
        this.store = store;
        this.parent = parent;
        this.districtid = districtid;
        this.width = width;
        this.height = height;
        this.year = year;
        this.value = value;
        this.color = color;
        this.plant = plant;
        this.city = city;
        this.group = new THREE.Group();
        this.parent.add(this.group);
        this.model = null;
        this.baseScale = 0.9;
        this.targetScale = this.baseScale;
        this.hoverTimer = null;
        this.load();
    }

    async load() {
        const geometry = new THREE.BoxGeometry(this.width, this.height, this.width);
        const material = new THREE.MeshStandardMaterial({color: this.color});
        this.model = new THREE.Mesh(geometry, material);
        this.model.position.y = this.height / 2;
        this.model.position.z = -.7;
        this.model.scale.setScalar(this.baseScale);
        this.model.castShadow = true;
        this.model.receiveShadow = true;
        this.model.userData.type = "CHART_BAR";
        this.model.userData.instance = this;
        this.nameLabel = createLabel(`${this.plant} : ${this.year} - ${this.value} ha`, {fontSize: this.store.config.isSmall ? 13 : 13, position: new THREE.Vector3(0, 1, 0)});
        this.nameLabel.rotation.z = Math.PI / 2;
        this.nameLabel.visible = false;
        this.model.add(this.nameLabel);
        this.nameLabel.traverse(object => {object.userData.ignoreRaycast = true;});
        this.group.add(this.model);
        this.store.input.clickables.push(this.model);
    }

    update() {
        if (!this.model) return;
        const current = this.model.scale.x;
        const next = THREE.MathUtils.lerp(current, this.targetScale, 0.35);
        this.model.scale.setScalar(next);
    }

    setHover(hovered) {
        this.targetScale = hovered ? this.baseScale * 1.4 : this.baseScale;
        this.nameLabel.visible = hovered;
    }

    dispose() {
        // Kattintható objektum eltávolítása
        if (this.model) {
            this.store.input.clickables = this.store.input.clickables.filter(clickable => clickable !== this.model);
            this.model.geometry?.dispose();
            if (Array.isArray(this.model.material)) {this.model.material.forEach(material => material.dispose());
            } else {this.model.material?.dispose();}
        }
        // Felirat eltávolítása és erőforrásainak felszabadítása
        if (this.nameLabel) {
            this.model?.remove(this.nameLabel);
            this.nameLabel.traverse(object => {
                object.geometry?.dispose();
                if (Array.isArray(object.material)) {object.material.forEach(material => material.dispose());
                } else {object.material?.dispose();}
            });
        }
        // A teljes hasábcsoport eltávolítása
        this.parent.remove(this.group);
    }
}